<template>
  <v-container>
    <v-row class="mb-0">
      <v-col>
        <outbox />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Outbox from "@/components/Outbox";
export default {
  name: "App",
  props: ["year", "years"],
  components: { Outbox },
};
</script>